import styled from 'styled-components';

export const Grid = styled.div`
  box-sizing: border-box;
  width: 100%;
`;
